import { Component, ElementRef, Inject, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, OrderCustomerInfo, OrderCustomerModel, ChecklistSoldModel } from 't4core';

@Component({
    selector: 'why-not-sold',
  templateUrl: './ChecklistSoldDialog.html',
  styleUrls: ['./ChecklistSoldDialog.css']
})
export class ChecklistSoldDialog extends DialogBase implements OnInit {
  public vehicleId: string;
  public checklist: ChecklistSoldModel;
  public isLoading: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<ChecklistSoldDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("ChecklistSoldDialog");
    this.vehicleId = data.vehicleId;
  }

  public async ngOnInit() {
    this.isLoading = true;
    var result = await this.Api.get<ChecklistSoldModel>("/TurboOrder/ChecklistSold", { vehicleId: this.vehicleId });
    this.checklist = result;
    this.isLoading = false;
  }

  public static async open(dialog: MatDialog, vehicleId: string) {
    var dlg = dialog.open(ChecklistSoldDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "500px",
      data: {
        vehicleId: vehicleId
      }
    });
  }
}
